import request from '@/utils/request'


  
export function queryLampSiteInfo(data) {
  return request.post("/lamp/queryLampSiteInfo", data);
}


export function queryDevice(data) {
  return request.get("/lamp/queryDevice", {cateId:data});
}

export function device(data) {
  return request.post("/lamp/device", data);
}
export function saveDevice(data) {
  return request.post("/lamp/device/add", data);
}

export function deviceTiming(data) {
  return request.post("/lamp/deviceTiming", data);
}

export function lightUpLamp(orderId) {
  return request.post("/lamp/lightUpLamp/"+orderId);
}

export function meritsList(productId) {
  // return request.get("/lamp/meritsList/" + type, {}, { login: false });
  return request.get("/lamp/meritsList/"+productId);
}

export function queryDeviceByProductId(productId) {
  return request.get("/lamp/queryDevice/"+productId);
}
// export default { queryLampSiteInfo }
